// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHierarchyNode
 */
export interface IHierarchyNode {
    /**
     * 
     * @type {number}
     * @memberof IHierarchyNode
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHierarchyNode
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IHierarchyNode
     */
    matches_query?: boolean;
    /**
     * 
     * @type {Array<IHierarchyNode>}
     * @memberof IHierarchyNode
     */
    children?: Array<IHierarchyNode>;
}

/**
 * Check if a given object implements the IHierarchyNode interface.
 */
export function instanceOfIHierarchyNode(value: object): value is IHierarchyNode {
    return true;
}

export function IHierarchyNodeFromJSON(json: any): IHierarchyNode {
    return IHierarchyNodeFromJSONTyped(json, false);
}

export function IHierarchyNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHierarchyNode {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'matches_query': json['matchesQuery'] == null ? undefined : json['matchesQuery'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(IHierarchyNodeFromJSON)),
    };
}

export function IHierarchyNodeToJSON(json: any): IHierarchyNode {
    return IHierarchyNodeToJSONTyped(json, false);
}

export function IHierarchyNodeToJSONTyped(value?: IHierarchyNode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'matchesQuery': value['matches_query'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(IHierarchyNodeToJSON)),
    };
}

